export default __webpack_public_path__ + "static/media/03.d9985e07.webp";